/* eslint-disable react/self-closing-comp */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/* eslint-disable arrow-body-style */
import { Hub } from 'aws-amplify';

import { Message, Icon } from 'semantic-ui-react';
// material
import { styled } from '@mui/material/styles';
import { Box, Card, Container, Typography } from '@mui/material';
// Menu
import Menu from '../components/Menu';

// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function AdminLoginLoadInfo() {
  const navigate = useNavigate();

  useEffect(() => {
    Hub.listen('auth', (data) => {
      const { payload } = data;
      if (payload.event === 'signIn') {
        navigate('/dashboard/app', { replace: true });
      }
    });
  }, [navigate]);

  return (
    <RootStyle title="Connectez-vous à votre compte | Gestion des plaintes">
      <Menu />

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}></Typography>
        </SectionStyle>
      </MHidden>

      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Message icon>
              <Icon name="circle notched" loading />
            </Message>
          </Box>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
